<!--
  ~ Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='col-12' data-testid="attachment-list-item">
  <div class=' mt-none mx-xs mb-none'>
    <div class='d-flex align-items-center-forced'>
      <div class='text-align-center'>
        <i class='ui-icon-insert-drive-file color-primary file-icon'></i>
      </div>

      @if(attachment && attachment.fileName) {
        <div class='flex-1 px word-break-all' data-testid="attachment-filename">
                <span [pTooltip]='attachment.fileName'
                      *ngIf='attachment.fileName.length > fileNameLength;else fullName'>{{attachment.fileName | slice:0:fileNameLength}}
                  ...</span>
          <ng-template #fullName> {{attachment.fileName}} </ng-template>
        </div>
      }
      <div class='d-flex text-align-center'>
        <button *ngIf='canSync'
                type='button'
                pButton class='p-button-text'
                data-testid="sync-attachment-button"
                pTooltip="{{'utils.sync' | translate}}"
                tooltipPosition='top'
                wellDebounceClick [debounceTime]='60000'
                icon='fa-solid fa-rotate'
                (click)='onSync(attachment?.uuid)'>
        </button>
        <button pButton class='p-button-text'
                type='button'
                data-testid="download-attachment-button"
                [disabled]='!attachment?.fileStoreAttachmentUuid'
                icon='ui-icon-file-download'
                pTooltip="{{'utils.download' | translate}}"
                tooltipPosition='top'
                (click)='download(attachment?.fileStoreAttachmentUuid)'></button>
        <button *ngIf='canDelete'
                [disabled]='attachment?.officialDocument'
                type='button'
                pButton class='p-button-text'
                data-testid="delete-attachment-button"
                icon='ui-icon-delete'
                (click)='onDelete(attachment?.fileStoreAttachmentUuid)'>
        </button>
      </div>
    </div>
  </div>
</div>


